(() => {
  const initCatalog = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-product-grid]');
    const cards = Array.from(grid.querySelectorAll('.aig-card'));
    const size = root.querySelector('[data-filter-size]');
    const color = root.querySelector('[data-filter-color]');
    const sort = root.querySelector('[data-filter-sort]');
    let vibe = root.dataset.initialVibe || 'all';
    const priority = ['ai-is-going-to-kill-you-retro-prophecy-graphic-t-shirt','ai-life-guard','mushroom-monitors','hang-loosely','ai-is-going-to-kill-you-editorial-warning-graphic-t-shirt','the-company-man-allen-graphic-t-shirt','the-third-option','this-is-probably-fine-ai-is-going-to-kill-you'];
    cards.sort((a,b)=>(priority.includes(a.dataset.handle)?priority.indexOf(a.dataset.handle):99)-(priority.includes(b.dataset.handle)?priority.indexOf(b.dataset.handle):99));
    const rows = cards.map((card, index) => ({card, index, variants: JSON.parse(card.dataset.variants || '[]')}));
    Array.from(new Set(rows.flatMap(row => row.variants.map(v => v.color)))).sort().forEach(name => color.add(new Option(name, name)));
    const update = () => {
      const ordered = [...rows];
      if (sort?.value === 'az' || sort?.value === 'za') ordered.sort((a,b) => a.card.dataset.title.localeCompare(b.card.dataset.title) * (sort?.value === 'za' ? -1 : 1));
      else if (sort?.value === 'newest') ordered.sort((a,b) => Number(b.card.dataset.created) - Number(a.card.dataset.created));
      else ordered.sort((a,b) => a.index-b.index);
      let count = 0;
      const home = root.hasAttribute('data-home-grid') && vibe === 'all' && !size.value && !color.value && sort?.value === 'featured';
      ordered.forEach(row => {
        const match = (vibe === 'all' || row.card.dataset.category === vibe) && row.variants.some(v => v.available && (!size.value || v.size === size.value) && (!color.value || v.color === color.value));
        row.card.hidden = !match || (home && count >= 8);
        if (match) count++;
        grid.appendChild(row.card);
      });
      root.querySelectorAll('[data-vibe]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vibe === vibe)));
      root.querySelector('.aig-filter-empty').hidden = count > 0;
      root.querySelector('[data-filter-status]').textContent = count + ' tees';
    };
    root.querySelectorAll('[data-vibe]').forEach(button => button.addEventListener('click', () => {vibe = button.dataset.vibe; update();}));
    [size,color,sort].filter(Boolean).forEach(select => select.addEventListener('change',update));
    root.querySelector('[data-reset-filters]').addEventListener('click',()=>{vibe='all';size.value='';color.value='';if(sort)sort.value='featured';update();});
    update();
  };
  const init = () => document.querySelectorAll('[data-aig-catalog]').forEach(initCatalog);
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-gallery-step]');
    if (arrow) {
      const gallery = arrow.closest('media-gallery');
      const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list__item button'));
      const active = thumbnails.findIndex(item => item.getAttribute('aria-current') === 'true');
      const next = (Math.max(0,active) + Number(arrow.dataset.galleryStep) + thumbnails.length) % thumbnails.length;
      thumbnails[next]?.click();
    }
    const pause = event.target.closest('[data-announcement-pause]');
    if (pause) {
      const banner = pause.closest('.aig-announcement');
      const paused = banner.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed',String(paused));
      pause.querySelector('[aria-hidden]').textContent = paused ? '▶' : 'Ⅱ';
    }
    const button = event.target.closest('.aig-card .aig-swatch');
    if (button) {
      const card = button.closest('.aig-card');
      card.querySelectorAll('.aig-swatch').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch===button)));
      const front = card.querySelector('.aig-card__front');
      const folded = card.querySelector('.aig-card__folded');
      if (front && button.dataset.front) {front.removeAttribute('srcset');front.src=button.dataset.front;}
      if (folded && button.dataset.folded) {folded.removeAttribute('srcset');folded.src=button.dataset.folded;}
      card.querySelectorAll('a').forEach(link=>link.href=button.dataset.url);
    }
    document.querySelectorAll('.aig-vibe-menu[open],.aig-mobile-nav[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.aig-vibe-menu[open],.aig-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('change',event=>{const input=event.target.closest('input[data-option-name="Color"]');if(input){const label=input.closest('fieldset')?.querySelector('[data-selected-color]');if(label)label.textContent=input.value;}});
  document.addEventListener('shopify:section:load',init);
  init();
  const initialColors = {'aig2ky-tie-dye':'Lagoon Blue','lemmings':'Burnt Orange','shark-machina':'Island Reef','ai-life-guard':'Ivory','mushroom-monitors':'Yam','hang-loosely':'True Navy','the-third-option':'Bay','this-is-probably-fine':'White'};
  document.querySelectorAll('.aig-card').forEach(card => {
    const name = initialColors[card.dataset.handle];
    const buttons = Array.from(card.querySelectorAll('.aig-swatch'));
    const swatch = buttons.find(button => button.getAttribute('aria-label')===name && !button.disabled) || buttons.find(button => button.getAttribute('aria-pressed')==='true');
    if (swatch) swatch.click();
  });
})();
